import { CalendarProviderType } from '../store/schema/CalendarProviderType';
import type { SubscribeCalendarRequest } from '../types/SubscribeCalendarRequest';
import type { TeamSnapSubscribeCalendarRequest } from '../types/TeamSnapSubscribeCalendarRequest';
import { makePostRequest } from 'owa-ows-gateway';

interface UpdateCalendarSubscriptionsOfCalendarProviderRequest {
    subscribeRequests: SubscribeCalendarRequest[];
    unsubscribeCalendarIds: string[];
}

export async function updateCalendarSubscriptionsOfCalendarProvider(
    providerType: CalendarProviderType.TeamSnap,
    calendarProviderAccountId: string,
    subscribeRequests: TeamSnapSubscribeCalendarRequest[],
    unsubscribeCalendarIds: string[]
): Promise<void>;
export async function updateCalendarSubscriptionsOfCalendarProvider(
    providerType: Exclude<CalendarProviderType, CalendarProviderType.TeamSnap>,
    calendarProviderAccountId: string,
    subscribeRequests: SubscribeCalendarRequest[],
    unsubscribeCalendarIds: string[]
): Promise<void>;
export async function updateCalendarSubscriptionsOfCalendarProvider(
    providerType: CalendarProviderType,
    calendarProviderAccountId: string,
    subscribeRequests: SubscribeCalendarRequest[],
    unsubscribeCalendarIds: string[]
): Promise<void> {
    const url =
        providerType === CalendarProviderType.TeamSnap
            ? `ows/api/beta/calendarProviderAccounts/${calendarProviderAccountId}/batch/calendars/teamsnap`
            : `ows/api/beta/calendarProviderAccounts/${calendarProviderAccountId}/batch/calendars`;

    const req: UpdateCalendarSubscriptionsOfCalendarProviderRequest = {
        subscribeRequests,
        unsubscribeCalendarIds,
    };

    await makePostRequest(
        url,
        req,
        undefined /*correlationId*/,
        undefined /*returnFullResponse*/,
        undefined /*customHeaders*/,
        true /*throwServiceError*/
    );
}
